import styled from 'styled-components';

export const FlowWrapper = styled.div`
  position: relative;
  height: calc(98vh - 106px);
  width: 100%;
  max-width: 2440px;

  .react-flow__handle {
    min-height: 8px;
    min-width: 20px;

    border-radius: 3px;
  }

  .react-flow__handle-right,
  .react-flow__handle-left {
    min-height: 20px;
    min-width: 8px;
  }

  &.flow-read-only {
    .read-only-disable input,
    .read-only-disable textarea,
    .read-only-disable select {
      pointer-events: none;
      opacity: 0.7;
    }

    .read-only-hide {
      visibility: hidden !important;
      pointer-events: none !important;
    }
  }
`;
